export const LISTING = 'COIN_SETTING_LIST';
export const STORE = "COIN_SETTING_STORE";
export const DETAILS = "COIN_SETTING_DETAILS";
export const UPDATE = "COIN_SETTING_UPDATE";